import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

const modulesFiles = require.context(
  './modules',
  true,
  /^(?!.*\/actions\/(?!index\.js$).*$).*\.js$/
)

const modules = modulesFiles
  .keys()
  .reduce((modules, modulePath) => {
    try {
      // 处理路径，支持文件夹和单独的 .js 文件
      const moduleName = modulePath
        .replace(/^\.\/(.*)\.\w+$/, '$1') // 移除文件扩展名
        .replace(/\/index$/, '') // 移除文件夹中的 index
        .replace(/\//g, '_') // 将路径中的斜杠替换为下划线
      const value = modulesFiles(modulePath)
      if (value.default) {
        modules[moduleName] = value.default
      } else {
        console.error(
          `模块 ${moduleName} 未正确导出 default`
        )
      }
    } catch (error) {
      console.error(`加载模块 ${modulePath} 失败:`, error)
    }
    return modules
  }, {})

const store = new Vuex.Store({
  modules,
  getters
})

export default store
